/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleCommitmentShareToSelf extends models.BillingRuleBenefitDistributionBase {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleCommitmentShareToSelf");
    }

    getFixupPrototypeFunction() { return BillingRuleCommitmentShareToSelf.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleCommitmentShareToSelf>): BillingRuleCommitmentShareToSelf {
        let obj = Object.assign(new BillingRuleCommitmentShareToSelf(), model);
        BillingRuleCommitmentShareToSelf.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleCommitmentShareToSelf>): BillingRuleCommitmentShareToSelf {
        if (!model) return null;
        return BillingRuleCommitmentShareToSelf.newInstance(<BillingRuleCommitmentShareToSelf> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleCommitmentShareToSelf) {
        if (!obj) return;

        models.BillingRuleCommitmentShareToSelf.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleCommitmentShareToSelf): boolean {
        if (models.BillingRuleBenefitDistributionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleCommitmentShareToSelf.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
